import { isChrome, isMacOs } from "react-device-detect";

export const setManifest = (name = "ONMO+", url: string) => {
  if (isChrome && isMacOs) return;
  const myDynamicManifest = {
    scope: url,
    name: name,
    short_name: name,
    id: url,
    start_url: url,
    background_color: "#141414",
    theme_color: "#000000",
    display: "standalone",
    description: "Smart Console",
    icons: [
      {
        src: `${url}/pwa/favicon.ico`,
        sizes: "64x64 32x32 24x24 16x16",
        type: "image/x-icon",
        purpose: "any",
      },
      {
        src: `${url}/pwa/android-icon-192.png`,
        type: "image/png",
        sizes: "192x192",
        purpose: "any",
      },
      {
        src: `${url}/pwa/android-icon-192-maskable.png`,
        type: "image/png",
        sizes: "192x192",
        purpose: "maskable",
      },
      {
        src: `${url}/pwa/android-icon-512.png`,
        type: "image/png",
        sizes: "512x512",
        purpose: "any",
      },
      {
        src: `${url}/pwa/android-icon-512-maskable.png`,
        type: "image/png",
        sizes: "512x512",
        purpose: "maskable",
      },
    ],
    screenshots: [
      {
        src: `${url}/pwa/screenshot-mobile.png`,
        sizes: "1125x2000",
        type: "image/png",
        form_factor: "narrow",
      },
      {
        src: `${url}/pwa/screenshot-desktop.png`,
        sizes: "2000x1092",
        type: "image/png",
        form_factor: "wide",
      },
    ],
  };

  const stringManifest = JSON.stringify(myDynamicManifest);
  const blob = new Blob([stringManifest], { type: "application/json" });
  const manifestURL = URL.createObjectURL(blob);
  const div = document.querySelector("#my-manifest-placeholder");

  if (div) {
    div.setAttribute("href", manifestURL);
  }

  const link = document.createElement("Link") as HTMLLinkElement;
  link.rel = "manifest";
  link.setAttribute("href", "data:application/json;charset=8" + stringManifest);
};
